import { DailyReportFieldModel, ReportTypeModel } from ".";

export class Type1Model {
    public Id: number;
    public Name: string;
    public IsReportRequired: boolean;
    public RequiredReport: ReportTypeModel[];
    public ShownReport: ReportTypeModel[];
    public AccountId: number;
    public SiteId: number;
    public Fields: DailyReportFieldModel[];
}



// WEBPACK FOOTER //
// ./src/app/models/type1-model.ts